import { Component, OnInit, Input, HostBinding, ViewChild, ElementRef } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { IPictureData } from '../../shared/components/picture/picture.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ILinkWithColor } from 'src/app/shared/interface/link';
import { applyTitleSettings, applySubtitleSettings } from '../../shared/utils/title-style-settings-utils';
import { ISubtitleStyleSettings, ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { IRteStyleSettings } from '../../shared/interface/rte-style-settings';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';

interface ITwoColumnsPanelData {
  title: IUProperty<string>;
  subtitle: IUProperty<string>;
  capitalizeTitle?: IUProperty<string[]>;
  descriptionLeft?: IUProperty<string>;
  descriptionRight?: IUProperty<string>;
  alignItems?: IUProperty<boolean>;
  backgroundImage?: IUProperty<IPictureData>;
  links?: IUProperty<ILinkWithColor[]>;
  topWave: IUProperty<boolean>;
  bottomWave: IUProperty<boolean>;

  rteStyleSettingsComposition?: IRteStyleSettings;
  titleStyleSettingsComposition?: ITitleStyleSettings;
  subtitleStyleSettingsComposition?: ISubtitleStyleSettings;
}

@Component({
  selector: 'app-two-columns-panel',
  templateUrl: './two-columns-panel.component.html',
  styleUrls: ['./two-columns-panel.component.less']
})
export class TwoColumnsPanelComponent implements OnInit {
  @Input() data: ITwoColumnsPanelData;
  strLeft;
  strRight;

  @ViewChild('panelEl', { static: false }) panelElRef: ElementRef<HTMLElement>;
  @ViewChild('titleEl', { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild('subtitleEl', { static: false }) subtitleEl: ElementRef<HTMLElement>;
  @ViewChild('wrapperEl', { static: false }) wrapperEl: ElementRef<HTMLElement>;

  constructor(private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.strLeft = this.assembleHTMLItem(this.data.descriptionLeft.value);
    this.strRight = this.assembleHTMLItem(this.data.descriptionRight.value);
  }

  ngAfterViewInit(): void {
    if (this.panelElRef && this.panelElRef.nativeElement && this.data && this.data.backgroundImage && this.data.backgroundImage.value) {
      this.panelElRef.nativeElement.style.backgroundImage = 'url(' + this.data.backgroundImage.value.src + ')';
      this.panelElRef.nativeElement.style.backgroundSize = 'cover';
      this.panelElRef.nativeElement.style.backgroundRepeat = 'no-repeat';
    }

    this.applyCustomTitleStyling(this.data);
    applyRteSettings(this.data, this.wrapperEl);
  }

  private applyCustomTitleStyling(d: ITwoColumnsPanelData) {
    if (d && d.capitalizeTitle && d.capitalizeTitle.value) {
      d.capitalizeTitle.value.forEach(item => {
        switch (item) {
          case 'Title': if (this.titleEl && this.titleEl.nativeElement) this.titleEl.nativeElement.style.textTransform = 'uppercase';
            break;
          case 'Subtitle': if (this.subtitleEl && this.subtitleEl.nativeElement) this.subtitleEl.nativeElement.style.textTransform = 'uppercase';
        }
      });
    }
    applyTitleSettings(d, this.titleEl);
    applySubtitleSettings(d, this.subtitleEl)
  }

  assembleHTMLItem(item: string) {
    return this._sanitizer.bypassSecurityTrustHtml(item);
  }
}

